module.exports = __webpack_public_path__ + "static/media/edit.cf03a3ba.svg";